import styles from './styles.module.css';
import React, { useEffect, useState } from 'react';

const Monedas = (props) => {
  const API_COTIZACIONES_GOOGLE = '/api/cotizaciones/google';
  const API_COTIZACIONES_INTRADAY = '/api/cotizaciones/intraday';

  const [currencyMap, setCurrencyMap] = useState({});
  const { use_api = true } = props;

  const defaultValues = {
    dolar_oficial: {
      etiqueta: 'Dólar Oficial',
      compra: props.dolar_oficial_compra || '',
      venta: props.dolar_oficial_venta || '',
      simbolo: '$',
    },
    dolar_blue: {
      etiqueta: 'Dólar Blue',
      compra: props.dolar_blue_compra || '',
      venta: props.dolar_blue_venta || '',
      simbolo: '$',
    },
    dolar_ccl: {
      etiqueta: 'Dólar CCL',
      compra: props.dolar_ccl_compra || '',
      venta: props.dolar_ccl_venta || '',
      simbolo: '$',
    },
    dolar_tarjeta: {
      etiqueta: 'Dólar Tarjeta',
      compra: props.dolar_tarjeta_compra || '',
      venta: props.dolar_tarjeta_venta || '',
      simbolo: '$',
    },
    dolar_mayorista: {
      etiqueta: 'Dólar Mayorista',
      compra: props.dolar_mayorista_compra || '',
      venta: props.dolar_mayorista_venta || '',
      simbolo: '$',
    },
  };

  const isValidVariation = (variation) => {
    if (variation === null || variation === undefined || variation === '') {
      return false;
    }

    const parsedVariation = parseFloat(
      String(variation)
        .replace('%', '')
        .replace(',', '.')
        .trim()
    );

    if (isNaN(parsedVariation)) {
      return false;
    }

    /**
     * Cuando la API no responde correctamente puede llegar -100 o 100.
     * En esos casos no mostramos el dato.
     */
    if (parsedVariation === -100 || parsedVariation === 100) {
      return false;
    }

    return true;
  };

  const getVariationNumber = (variation) => {
    return parseFloat(
      String(variation)
        .replace('%', '')
        .replace(',', '.')
        .trim()
    );
  };

  const fetchData = async () => {
    if (!use_api) {
      setCurrencyMap({ ...defaultValues });
      return;
    }

    try {
      const [resGoogle, resIntraday] = await Promise.all([
        fetch(API_COTIZACIONES_GOOGLE),
        fetch(API_COTIZACIONES_INTRADAY),
      ]);

      let googleData = [];
      let intradayData = [];

      if (resGoogle.ok) {
        const data = await resGoogle.json();
        googleData = data.result || [];
      }

      if (resIntraday.ok) {
        const data = await resIntraday.json();

        if (Array.isArray(data.result) && data.result.length > 0) {
          const byma = data.result[0];

          intradayData = [
            {
              moneda: 'bymaValue',
              etiqueta: 'DOLAR BYMA*',
              venta: byma.bymaValue
                ? byma.bymaValue
                    .toFixed(2)
                    .replace('.', ',')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                : '',
              simbolo: '$',
              fecha: byma.date,
              hora: byma.time,
            },
            {
              moneda: 'cclValue',
              etiqueta: 'DOLAR CCL*',
              venta: byma.cclValue
                ? byma.cclValue
                    .toFixed(2)
                    .replace('.', ',')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                : '',
              simbolo: '$',
              fecha: byma.date,
              hora: byma.time,
            },
          ];
        }
      }

      const mixeData = [...googleData, ...intradayData];

      setCurrencyMap(mixeData);
    } catch (err) {
      console.error('Hubo un error al intentar completar la peticion', err);
      setCurrencyMap({ ...defaultValues });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={styles['container-monedas']}>
      <div className={styles['monedas-scroll']}>
        {Object.keys(currencyMap).map((curr, index) => {
          const currency = currencyMap[curr];
          const showVariation = isValidVariation(currency.variacion);
          const variationNumber = showVariation
            ? getVariationNumber(currency.variacion)
            : null;

          return (
            <div className={styles['moneda-box']} key={`${curr}-${index}`}>
              <div className={styles['moneda-titulo']}>
                {currency.etiqueta}
              </div>

              <div className={styles['moneda-valores']}>
                <div>
                  <strong>
                    {currency.compra ? `${currency.simbolo} ${currency.compra}` : ''}
                  </strong>

                  {currency.simbolo === '$' && currency.compra !== '' && (
                    <span className={styles['label']}>
                      {currency.compra ? ' Compra' : ''}
                    </span>
                  )}
                </div>

                <div>
                  <strong>
                    {currency.venta !== '' && `${currency.simbolo}${currency.venta}`}
                  </strong>

                  {currency.simbolo === '$' && currency.venta !== '' && (
                    <span className={styles['label']}> Venta</span>
                  )}
                </div>

                {showVariation && (
                  <span
                    className={
                      variationNumber >= 0
                        ? styles['moneda-alta']
                        : styles['moneda-baja']
                    }
                  >
                    {currency.variacion}%
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles['boton-mas']}>
        <div className={styles['boton-mas-a']}>
          <a href="/monedas">Ver más</a>
        </div>

        <span className={styles['cotizaciones-firma']}>
          Datos provistos por BYMA (*)
          <img
            src="https://www.ellitoral.com/collections/utiles-diseno/logo-byma-firma___67b76973215744001a6c129d.png"
            title="byma"
            alt="Logo BYMA"
            width={64}
            height={26}
            loading="lazy"
          />
        </span>
      </div>
    </div>
  );
};

export default Monedas;